import { Box, styled } from '@mui/material';

export const StyledDashboardRowIcon = styled(Box)(() => ({
  background: '#f0f0f0',
  height: '48px',
  width: '48px',
}));

export const StyledDashboardRowViewButton = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'row',
  gap: '10px',
}));

export const StyledDashboardSectionSkeletonContainer = styled(Box)(() => ({
  alignItems: 'flex-start',
  alignSelf: 'stretch',
  display: 'flex',
  flexDirection: 'row',
  gap: '16px',
  marginBottom: '10px',
  ml: 4,
  mr: 4,
  border: `1px solid #E9EDF2`,
  padding: '16px',
  borderRadius: '8px',
  boxShadow: `0px 4px 20px 0px rgba(11, 27, 80, 0.06), 0px 1px 1px 0px rgba(11, 27, 80, 0.03)`,
  marginLeft: '32px',
  marginRight: '32px',
}));
